<div class="credit-card-add-wrapper">
  @if (stripeNotLoaded) {
    <mat-error>
      We're having trouble communicating with Stripe for credit card handling. Please refresh your browser to continue.
    </mat-error>
  }

  @if (errorBanner) {
    <sonder-success-error-banner [isSuccess]="false" [message]="errorBanner"></sonder-success-error-banner>
  }

  @if (cardErrorMessage) {
    <sonder-success-error-banner
      class="card-error"
      role="alert"
      [message]="cardErrorMessage"
    ></sonder-success-error-banner>
  }

  <form
    [formGroup]="ccForm"
    method="post"
    class="stripe-card-form"
  >
    <sonder-form-body>
      @if (useInline && isProposeATime) {
        <iris-form-field
          class="field-width-60"
          label="Name on Card"
          data-test="payment-add-card-name-on-card-header-text"
        >
          <iris-text-input
            name="name"
            formControlName="name"
            [placeholder]="isProposeATime ? 'First M. Last' : ''"
            data-test="field-card-name"
          ></iris-text-input>
        </iris-form-field>
      }
      <sonder-form-field
        class="credit-card-input field-width-50"
        label="Card Number *"
        [overrideLabelCase]="true"
        data-test="payment-add-card-card-number-header-text"
      >
        <div id="stripe-card-number-element"></div>
      </sonder-form-field>
      <sonder-form-field
        class="field-width-20"
        label="CVV *"
        [overrideLabelCase]="true"
        data-test="payment-add-card-cvv-header-text"
      >
        <div id="stripe-card-cvc-element"></div>
      </sonder-form-field>
      <sonder-form-field
        class="field-width-30"
        label="Expiration *"
        data-test="payment-add-card-expiration-header-text"
      >
        <div id="stripe-card-exp-element"></div>
      </sonder-form-field>
      <sonder-form-field
        class="field-width-40"
        label="Billing ZIP Code *"
        [overrideLabelCase]="true"
        data-test="payment-add-card-zipcode-header-text"
      >
        <div id="stripe-card-zip-element"></div>
      </sonder-form-field>

      @if (!useInline || !isProposeATime) {
        <iris-form-field
          class="field-width-60"
          label="Name on Card *"
          data-test="payment-add-card-name-on-card-header-text"
        >
          <iris-text-input
            name="name"
            formControlName="name"
            data-test="field-card-name"
          ></iris-text-input>
        </iris-form-field>
      }

      @if (!useInline) {
        <iris-form-field
          class="field-width-100"
          label="Card Nickname"
          data-test="payment-add-card-card-nickname-header-text"
          [showOptionalTag]="false"
        >
          <iris-text-input
            name="nickname"
            formControlName="nickname"
            data-test="field-card-nickname"
          ></iris-text-input>
        </iris-form-field>
      }
    </sonder-form-body>

    @if (showFinancialAgreement) {
      <form
        [formGroup]="financialPolicyForm"
        class="financial-responsibility-agreement"
      >
        <iris-checkbox
          formControlName="acceptedFinancialPolicy"
          data-test="payment-authorization-checkbox-text"
        >
          I agree to the
          <a
            class="iris-link-responsive"
            [href]="financialResponsibilityAgreement"
            target="_blank"
          >Financial Responsibility Agreement</a>,
          and authorize SonderMind to charge the payment card on file in accordance with those terms.
        </iris-checkbox>
      </form>
    }

    @if (!useInline) {
      <iris-button-container>
        <iris-button
          [type]="IrisButtonTypes.PRIMARY"
          [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
          id="pendo-credit-card-save"
          data-test="button-save"
          [disabled]="submitting || !getStripeFormValidity()"
        >
          Save
        </iris-button>
      </iris-button-container>
    }
  </form>

</div>
